export function getDefaultValue(field) {
    switch (field.type) {
        case "list":
            return [];
        case "checkbox":
            return false;
        case "object":
            return field.schema.fields.reduce((acc, f) => {
                acc[f.name] = getDefaultValue(f);
                return acc;
            }, {});
        case "datetime":
            // yyyy-MM-ddThh:mm
            // or use moment.js, etc
            const d = new Date();
            const pad = (n) => n.toString().padStart(2, "0");
            return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
        case "select":
            return field.options[0];
        case "number":
            return "";
        default:
            return "";
    }
}

export function getDefaultValues(schema) {
    return schema.fields.reduce((acc, field) => {
        acc[field.name] = getDefaultValue(field);
        return acc;
    }, {});
}
